import { render, staticRenderFns } from "./EditorHeader.vue?vue&type=template&id=01832a62&"
import script from "./EditorHeader.vue?vue&type=script&lang=ts&"
export * from "./EditorHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports